import { __extends } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import StockProductService from '@/modules/stocks/StockProductService';
var stockReport = {
  serial: '',
  frequency: '',
  name: '',
  created_at: '',
  price: '',
  show_alert: ''
}; // interface ReportRes {
//   data: IProductReportModel[];
//   total: number;
//   sum?: Sum;
// }

var StockReportModel =
/** @class */
function (_super) {
  __extends(StockReportModel, _super);

  function StockReportModel() {
    var _this = _super.call(this, stockReport, StockProductService) || this;

    _this.modelName = 'Venta';
    _this.request = 'JSON';
    return _this;
  }

  return StockReportModel;
}(BaseModel);

export default StockReportModel;